/**
 * Agrupación VISUAL de estados GI Capital. Independiente del ciclo analítico
 * fijo usado por métricas y SLA (sin_procesar/en_proceso/terminado).
 */
export const REQUIRED_GROUP_IDS = ['sin_procesar', 'en_proceso', 'terminado'];

export const DEFAULT_STATE_GROUPS = Object.freeze([
  { groupId: 'sin_procesar', name: 'Sin procesar', order: 1 },
  { groupId: 'en_proceso', name: 'En proceso', order: 2 },
  { groupId: 'futuros', name: 'Futuros', order: 3 },
  { groupId: 'terminado', name: 'Terminado', order: 4 }
]);

export function metricCycleForState(state) {
  if (state?.condition === 'cerrado') return 'terminado';
  return state?.countsAsContacted === true ? 'en_proceso' : 'sin_procesar';
}

/** Legacy: hasta desplegar GAS nuevo no existe groupId persistido. */
export function groupIdForState(state) {
  const explicit = String(state?.groupId || '').trim();
  return explicit || metricCycleForState(state);
}

export function normalizeStateGroups(groups) {
  const input = Array.isArray(groups) ? groups : DEFAULT_STATE_GROUPS;
  return input.map((group, i) => ({
    groupId: String(group?.groupId || '').trim(),
    name: String(group?.name || '').trim(),
    order: group?.order == null || group.order === '' ? i + 1 : Number(group.order)
  })).sort((a, b) => a.order - b.order || a.name.localeCompare(b.name, 'es'));
}

export function nextNewGroup(groups) {
  const current = Array.isArray(groups) ? groups : [];
  const names = new Set(current.map((g) => String(g?.name || '').toLocaleLowerCase('es-CL')));
  const ids = new Set(current.map((g) => String(g?.groupId || '')));
  let suffix = 1;
  let name;
  let groupId;
  do {
    name = suffix === 1 ? 'Nuevo grupo' : 'Nuevo grupo ' + suffix;
    groupId = suffix === 1 ? 'nuevo_grupo' : 'nuevo_grupo_' + suffix;
    suffix += 1;
  } while (names.has(name.toLocaleLowerCase('es-CL')) || ids.has(groupId));
  return {
    groupId,
    name,
    order: current.reduce((max, group) => Math.max(max, Number(group?.order) || 0), 0) + 1
  };
}

export function validateStateGroups(groups, states) {
  if (!Array.isArray(groups) || groups.length < REQUIRED_GROUP_IDS.length) {
    return 'La configuración necesita los tres grupos base.';
  }
  const seenIds = new Set();
  const seenNames = new Set();
  for (const group of groups) {
    const id = String(group?.groupId || '');
    const name = String(group?.name || '').trim();
    if (!/^[a-z][a-z0-9_]{0,63}$/.test(id)) return 'Hay un ID de grupo inválido.';
    if (seenIds.has(id)) return 'Hay un ID de grupo repetido.';
    if (!name || name.length > 90) return 'Cada grupo requiere un nombre de 1 a 90 caracteres.';
    if (name.startsWith('=')) return 'El nombre del grupo no puede ser una fórmula de Sheets.';
    const key = name.toLocaleLowerCase('es-CL');
    if (seenNames.has(key)) return 'No puede haber dos grupos con el mismo nombre.';
    if (!Number.isFinite(Number(group.order)) || Number(group.order) < 0) {
      return 'Hay un orden de grupo inválido.';
    }
    seenIds.add(id);
    seenNames.add(key);
  }
  for (const id of REQUIRED_GROUP_IDS) {
    if (!seenIds.has(id)) return 'No se puede borrar el grupo base ' + id + '.';
  }
  for (const state of Array.isArray(states) ? states : []) {
    const groupId = groupIdForState(state);
    if (!seenIds.has(groupId)) {
      return 'El estado «' + String(state?.name || state?.stateId || '?') +
        '» pertenece a un grupo inexistente.';
    }
  }
  return '';
}
